//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import * as React from 'react';
import { connect } from 'react-redux';
import Redux, { bindActionCreators } from 'redux';
import styled from 'styled-components';
import {
  Modal,
  ModalBody,
  ModalHeader,
  VerticalDivider,
} from 'unison';

import { instagramPostUploaderActions } from '@instagram-post-uploader/actions/instagramPostUploaderActions';
import FileSystemUploadForm from '@instagram-post-uploader/components/file-system-upload-form/FileSystemUploadForm';
import InstagramPostUploadForm from '@instagram-post-uploader/components/post-upload-form/InstagramPostUploadForm';
import { ICuralateStore } from '@models/AppState';

function mapStateToProps(state: ICuralateStore) {
  return {
    isModalOpen: state.instagramPostUploader.isModalOpen,
  };
}

function mapDispatchToProps(dispatch: Redux.Dispatch) {
  return {
    actions: {
      postUploader: bindActionCreators(instagramPostUploaderActions, dispatch),
    },
  };
}

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class InstagramPostUploader extends React.Component<Props> {
  public handleModalClose = () => {
    this.props.actions.postUploader.resetErrorMessage();
    this.props.actions.postUploader.closeInstagramPostUploaderModal();
  }

  public render() {
    const { isModalOpen } = this.props;

    return (
      <CustomModal isOpen={ isModalOpen }>
        <ModalHeader onCancel={ this.handleModalClose }>
          Add Media
        </ModalHeader>
        <ModalBody>
          <Wrapper>
            <InstagramPostUploadFormWrapper>
              <InstagramPostUploadForm />
            </InstagramPostUploadFormWrapper>
            <VerticalDivider>Or</VerticalDivider>
            <FileSystemUploadFormWrapper>
              <FileSystemUploadForm />
            </FileSystemUploadFormWrapper>
          </Wrapper>
        </ModalBody>
      </CustomModal>
    );
  }
}

// Can be replaced with `cu-very-wide-measure` css class or else grab width from theme
// when either of those exists in unison
const CustomModal = styled(Modal)`
  width: 768px;
`;

const Wrapper = styled.div`
  display: flex;
  align-content: center;
`;

const InstagramPostUploadFormWrapper = styled.div`
  flex: 0 1 50%;
  display: flex;
  flex-flow: column;
`;

const FileSystemUploadFormWrapper = styled.div`
  flex: 0 1 50%;
  text-align: center;
`;

export default connect(mapStateToProps, mapDispatchToProps)(InstagramPostUploader);
